import React from 'react'
import { Modal, modalVisibility, ModalVisibilityProps, openModal } from 'sb-modal'

import messages from './messages'


const DowngradeSuccessModal: React.FunctionComponent<ModalVisibilityProps> = ({ closeModal, onClose }) => (
  <Modal
    className="humbleBgColor"
    iconName="glad"
    title={messages.title}
    text={messages.text}
    primaryButton={{
      title: messages.buttonTitle,
      onClick: closeModal,
    }}
    onClose={onClose}
  />
)


export const openDowngradeSuccessModal = () => openModal('downgradeSuccess')


export default modalVisibility('downgradeSuccess', DowngradeSuccessModal)
